import React from 'react';

const Privacy = () => {
  const styles = {
    container: {
      marginTop: '115px',
      maxWidth: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
      padding: '20px',
      lineHeight: '1.6',
      color: '#333',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    },
    heading: {
      color: '#2c3e50',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px',
      marginBottom: '20px'
    },
    section: {
      marginBottom: '25px'
    },
    h2: {
      color: '#3498db',
      fontSize: '1.3rem',
      marginBottom: '10px'
    },
    p: {
      marginBottom: '15px'
    },
    ul: {
      paddingLeft: '20px',
      marginBottom: '15px'
    },
    li: {
      marginBottom: '8px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Privacy Policy</h1>
      <p style={styles.p}>Last Updated: January 1, 2023</p>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>1. Information Collection</h2>
        <p style={styles.p}>We collect several types of information from and about users of our website, including:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Personal information such as name, email address, phone number</li>
          <li style={styles.li}>Demographic information such as postcode, preferences, and interests</li>
          <li style={styles.li}>Technical information including IP address, browser type, and operating system</li>
          <li style={styles.li}>Usage data about how you use our website and services</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>2. Use of Collected Information</h2>
        <p style={styles.p}>We use the information we collect for various purposes:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>To provide and maintain our service</li>
          <li style={styles.li}>To notify you about changes to our service</li>
          <li style={styles.li}>To allow you to participate in interactive features</li>
          <li style={styles.li}>To provide customer support</li>
          <li style={styles.li}>To gather analysis or valuable information for improvement</li>
          <li style={styles.li}>To monitor usage of our service</li>
          <li style={styles.li}>To detect, prevent and address technical issues</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>3. Data Security</h2>
        <p style={styles.p}>We implement appropriate technical and organizational measures to protect personal data against unauthorized access, alteration, disclosure, or destruction. These include:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>SSL encryption for data transmission</li>
          <li style={styles.li}>Regular security audits</li>
          <li style={styles.li}>Access controls and authentication procedures</li>
          <li style={styles.li}>Employee training on data protection</li>
        </ul>
        <p style={styles.p}>Despite these measures, no method of transmission over the Internet or electronic storage is 100% secure.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>4. Data Retention</h2>
        <p style={styles.p}>We retain personal data only for as long as necessary to fulfill the purposes for which it was collected, including for satisfying any legal, accounting, or reporting requirements.</p>
        <p style={styles.p}>To determine the appropriate retention period, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure, the purposes for which we process your personal data, and applicable legal requirements.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>5. Your Rights</h2>
        <p style={styles.p}>You have certain rights regarding your personal information:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Right to access your personal data</li>
          <li style={styles.li}>Right to request correction of inaccurate data</li>
          <li style={styles.li}>Right to request deletion of your data</li>
          <li style={styles.li}>Right to object to processing of your data</li>
          <li style={styles.li}>Right to request restriction of processing</li>
          <li style={styles.li}>Right to data portability</li>
          <li style={styles.li}>Right to withdraw consent</li>
        </ul>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>6. Changes to This Policy</h2>
        <p style={styles.p}>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
        <p style={styles.p}>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
      </section>
      
      <section style={styles.section}>
        <h2 style={styles.h2}>7. Contact Us</h2>
        <p style={styles.p}>If you have any questions about this Privacy Policy, please contact us:</p>
        <p style={styles.p}>By email: privacy@pcds.in</p>
        <p style={styles.p}>By visiting this page on our website: www.pcds.in/contact</p>
        <p style={styles.p}>By mail: 1st Floor Mukta Tawar, Near Andheri Station, Andheri West, Mumbai - 400058</p>
      </section>
    </div>
  );
};

export default Privacy;